import type { PaymentPlan, TierPlan, Subscription } from '@/types/paymentPlans'
import { seg_getProduct, seg_getTotalAndCurrency, seg_track } from '@/helpers/segment'
import store from '@/store'

const waitForUpgrade = (x: Subscription, selectedPlan: PaymentPlan) =>
  x.plan?.id === selectedPlan?.id && !x.canceled

const waitForDowngrade = (x: Subscription, selectedPlan: PaymentPlan) =>
  Boolean(x.updated_plan?.id) && x.updated_plan?.id === selectedPlan?.id

const waitForReactivate = (x: Subscription, selectedPlan: PaymentPlan) =>
  x.updated_plan?.id !== selectedPlan?.id

type updateType = 'upgrade' | 'downgrade' | 'reactivate'

export const updateSubscription = async (
  selectedPlan: PaymentPlan,
  type: updateType = 'upgrade',
  onSuccess = () => {},
  onError = () => {},
  retryInterval = 100,
  maxRetries = 10,
) => {
  const { response } = await store.dispatch('api_call', {
    method: 'get',
    endpoint: 'account/settings/',
    hasCancel: false,
    mutation: 'api_account_settings',
    action: 'updateUserInfo',
  })
  if (
    type === 'reactivate'
      ? !response?.data?.subscriptions?.active_subscriptions?.every((x: Subscription) =>
          waitForReactivate(x, selectedPlan),
        )
      : !response?.data?.subscriptions?.active_subscriptions?.some((x: Subscription) =>
          type === 'upgrade' ? waitForUpgrade(x, selectedPlan) : waitForDowngrade(x, selectedPlan),
        )
  ) {
    if (maxRetries > 0) {
      setTimeout(
        () =>
          updateSubscription(
            selectedPlan,
            type,
            onSuccess,
            onError,
            Math.floor(retryInterval > 3000 ? retryInterval : retryInterval * 1.5),
            maxRetries - 1,
          ),
        retryInterval,
      )
    } else {
      onError()
    }
    return
  }
  await store.dispatch(
    store.getters.user_has_flag('ADYEN')
      ? 'payments_subscription_plan_v2'
      : 'payments_subscription_plan',
  )

  await store.dispatch('gameformat_set_gameformats')
  await store.dispatch('globals_action_reset')
  onSuccess()
}

export const segmentTrackSuccess = (selectedTierPlan: TierPlan, paymentMethod: string) => {
  const product = {
    plan: selectedTierPlan?.plan,
    price: { price: selectedTierPlan?.plan?.price },
  }
  seg_track('checkout_step_completed', {
    step: 2,
    checkout_type: 'Purchase Funnel',
    checkout_id: window.seg_checkout_id,
    payment_method: paymentMethod,
    ...seg_getTotalAndCurrency([product]),
    products: [seg_getProduct(product)],
  })
}
